(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-blog-v2"] && !window.DesignMode) return;
  try {
    
$(document).ready(function(){
    var sliderSelector = '.nov-section-blog .blog-slick-carousel';
    $(sliderSelector).slick({
        autoplay: false,
        autoplaySpeed: 6000,
        infinite: false,
        dots: false,
        arrows: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
        {
            breakpoint: 1400,
            settings: {
            slidesToShow: 4
            }
        },
        {
            breakpoint: 1200,
            settings: {
            slidesToShow: 3
            }
        },
        {
            breakpoint: 992,
            settings: {
            slidesToShow: 3
            }
        },
        {
            breakpoint: 768,
            settings: {
            slidesToShow: 2
            }
        },
        {
            breakpoint: 576,
            settings: {
            slidesToShow: 1
            }
        }
        ]
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-collection-v2"] && !window.DesignMode) return;
  try {
    
$(document).ready(function(){
    var sliderSelector = '.section-product-slider .collection-slick-carousel';
    $(sliderSelector).slick({
        autoplay: false,
        autoplaySpeed: 6000,
        infinite: false,
        dots: true,
        arrows: false,
        slidesToShow: 3,
        slidesToScroll: 3,
        rows: 2,
        responsive: [
        {
            breakpoint: 1400,
            settings: {
            slidesToShow: 4
            }
        },
        {
            breakpoint: 1200,
            settings: {
            slidesToShow: 3
            }
        },
        {
            breakpoint: 992,
            settings: {
            slidesToShow: 3
            }
        },
        {
            breakpoint: 768,
            settings: {
            slidesToShow: 2
            }
        },
        {
            breakpoint: 576,
            settings: {
            slidesToShow: 1
            }
        }
        ]
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-countdown-v1"] && !window.DesignMode) return;
  try {
    
$(document).ready(function(){
    var sliderSelector = '.section-product-deal-single .nov-slick-carousel';
    $(sliderSelector).slick({
        autoplay: false,
        autoplaySpeed: 6000,
        infinite: false,
        dots: true,
        arrows: false,
        slidesToShow: 2,
        slidesToScroll: 2,
        rows: 2,
        responsive: [
        {
            breakpoint: 1400,
            settings: {
            slidesToShow: 2
            }
        },
        {
            breakpoint: 1200,
            settings: {
            slidesToShow: 2
            }
        },
        {
            breakpoint: 992,
            settings: {
            slidesToShow: 2
            }
        },
        {
            breakpoint: 768,
            settings: {
            slidesToShow: 2
            }
        },
        {
            breakpoint: 576,
            settings: {
            slidesToShow: 1
            }
        }
        ]
    });

    function checkClasses(class_parent) {
        var rtl = false;
        var total = $(".slick-list .slick-active", class_parent).length;
        $(".slick-list .slick-slide", class_parent).removeClass("firstActiveItem lastActiveItem");
        $(".slick-list .slick-active", class_parent).each(function(index) {
            index === 0 && rtl === !1 ? $(this).addClass("firstActiveItem") : index === 0 && rtl === !0 && $(this).addClass("lastActiveItem"), index === total - 1 && total > 1 && rtl === !1 ? $(this).addClass("lastActiveItem") : index === total - 1 && total > 1 && rtl === !0 && $(this).addClass("firstActiveItem")
        })
    }

    checkClasses(sliderSelector);
    $(sliderSelector).on("after", function(event, slick, currentSlide, nextSlide) {
        checkClasses(sliderSelector)
    });

    $(document).on('click', '.product-deal__block-thumbmail .respone_image img', function(){
        var imSrc = $(this).attr('data-src');
        $('.product-deal__block-featured .product-thumbnail__featured').attr('data-src',imSrc);
        $('.product-deal__block-featured .product-thumbnail__featured').attr('src',imSrc);
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-testimonial-v1"] && !window.DesignMode) return;
  try {
    
$(document).ready(function(){
    var sliderSelector = '.section-testimonials .testimonial-slick-carousel';
    $(sliderSelector).slick({
        autoplay: false,
        autoplaySpeed: 6000,
        infinite: false,
        dots: false,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '<div class="arrow-prev"><i class="zmdi zmdi-chevron-left" aria-hidden="true"></i></div>',
        nextArrow: '<div class="arrow-next"><i class="zmdi zmdi-chevron-right" aria-hidden="true"></i></div>',
    });
});

  } catch(e) { console.error(e); }
})();
})();
